import { define } from "../preactement/define";
import { Label } from "../../Label";
import { parseBooleanAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['class-name', 'inversed', 'for', 'root-id'];
const Wrapper = _ref => {
  let {
    inversed,
    rootId,
    for: fieldId,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(Label, {
    ...otherProps,
    inversed: parseBooleanAttr(inversed),
    fieldId: fieldId,
    id: rootId
  });
};

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-label', () => Wrapper, {
  attributes
});